import { render, staticRenderFns } from "./DocumentHtmlViewer.vue?vue&type=template&id=bf9ff004&"
import script from "./DocumentHtmlViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentHtmlViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports